import * as React from "react";

function SvgWave1Inverted(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" {...props}><path d="M1341.4 151.4C1159 151.4 1087.2 71 912 71c-117.8 0-209.7 67.5-393.5 67.5-142.2 0-212.6-38.8-324.6-38.8S-10 135.6-10 135.6v75.9h1620V98.3c-110.6 40.2-181 53.1-268.6 53.1z" /></svg>;
}

export default SvgWave1Inverted;